<template>
  <div class="iq-card pl-3 pr-3 pt-5 pb-5">
    <div id="report-4">
      <div class="">
        <table style="width: 100%">
          <tr>
            <table style="width: 100%; margin: 0; padding: 0">
              <tr>
                <th style="width: 25%">
                  <div class="logo">
                    <img
                      src="../../../assets/images/vehicle-solutions-logo-type1.png"
                      class="img-fluid"
                    />
                  </div>
                </th>
                <th style="width: 75%">
                  <div class="text-right">
                    <h4
                      style="
                        color: #3f414d;
                        font-family: 'Roboto Condensed';
                        font-size: 3rem;
                        font-weight: 700;
                        line-height: 1;
                        margin-bottom: 0;
                      "
                    >
                      VSA EOM
                    </h4>
                    <h4
                      style="
                        color: #3f414d;
                        font-family: 'Roboto Condensed';
                        font-size: 3rem;
                        font-weight: 700;
                        line-height: 1;
                        margin-bottom: 0;
                      "
                    >
                      Invoicing
                    </h4>
                    <p>Dealer</p>
                    <p
                      style="
                        font-weight: 700;
                        margin-top: 20px;
                        margin-bottom: 0;
                      "
                    >
                      {{ invoiceYear }} to
                      {{ invoiceMonth }}
                    </p>
                  </div>
                </th>
              </tr>
            </table>
          </tr>

          <tr v-if="comGetRptData">
            <table style="width: 100%; margin: 0; padding: 0; margin-top: 25px">
              <tr class="tbl-header-blue">
                <th>Customer Name</th>
                <th class="tbl-right">Vehicle Price</th>
                <th class="tbl-right">Dealer Commission (Exc. GST)</th>
                <th class="tbl-right">GST</th>
                <th class="tbl-right">Total (Inc. GST)</th>
              </tr>
              <tr class="tbl-tr-no-data">
                <td colspan="5"></td>
              </tr>

              <template v-for="item in comGetRptData">
                <tr class="tbl-header-gray">
                  <td colspan="5">
                    <div class="row">
                      <div class="col-lg-9 col-md-9 col-12">
                        <div>
                          Dealer -
                          {{ item[0].dealer_basic_info.name }}
                        </div>
                        <!-- If Primary account contact doesn't here, this message will show -->
                        <div
                          class="invalid-feedback"
                          v-if="
                            errors['dealer.0.dealer_basic_info.accountEmail'] &&
                            dealerId == item[0].dealerId
                          "
                        >
                          {{
                            errors['dealer.0.dealer_basic_info.accountEmail'][0]
                          }}
                        </div>
                        <!-- If Primary account contact doesn't here, this message will show -->
                      </div>
                      <div class="col-lg-3 col-md-3 col-12 text-right">
                        <button
                          class="btn btn-primary btn-sm mr-2"
                          @click="fnSendInvoice(item)"
                        >
                          Email
                          <b-spinner
                            small
                            v-if="
                              loadingSendEmail && dealerId == item[0].dealerId
                            "
                          ></b-spinner>
                        </button>
                        <button
                          class="btn btn-primary btn-sm"
                          @click="fnDownloadInvoice(item)"
                        >
                          Download
                          <b-spinner
                            small
                            v-if="loading && dealerId == item[0].dealerId"
                          ></b-spinner>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
                <template v-for="record in item">
                  <tr class="tbl-border-bottom">
                    <td colspan="1">
                      <span v-if="record.client_basic_info">
                        {{
                          record.client_basic_info.firstName +
                          ' ' +
                          record.client_basic_info.lastName
                        }}
                      </span>
                    </td>
                    <td colspan="1" class="tbl-right">
                      $ {{ record.totalDriveAwayCost | with-decimal}}
                    </td>
                    <td colspan="1" class="tbl-right">
                      $ {{ getIncomeWithOutGST(record) | with-decimal }}
                    </td>
                    <td colspan="1" class="tbl-right">
                      $
                      {{ getGSTValue(record) |with-decimal}}
                    </td>
                    <td
                      colspan="1"
                      class="tbl-right"
                      v-if="record.client_lookup_values"
                    >
                      $
                      {{ getTotalValue(record) | with-decimal }}
                    </td>
                  </tr>
                </template>
                <template>
                  <tr>
                    <td colspan="1"></td>
                    <td colspan="1"></td>
                    <td colspan="1" class="tbl-right fw-700">
                      $ {{ getTotalIncomeWithOutGST(item) |with-decimal }}
                    </td>
                    <td colspan="1" class="tbl-right fw-700">
                      $ {{ getTotalGSTValue(item) |with-decimal}}
                    </td>
                    <td colspan="1" class="tbl-right fw-700">
                      $ {{ getTotalIncome(item)  |with-decimal }}
                    </td>
                  </tr>
                </template>

                <tr class="tbl-tr-no-data">
                  <td colspan="5"></td>
                </tr>
              </template>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td class="tbl-right fw-700">TOTAL</td>
                <td class="tbl-right fw-700">
                  $ {{ Number(comGetTotal)  |with-decimal}}
                </td>
              </tr>
            </table>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import store from '../../../store/modules/base.module'
import * as invoiceService from '../../../services/invoice.service'
import * as messageService from '../../../services/message.service'

export default {
  name: 'VSAEOMDEInvoice',
  props: ['prosData', 'invoiceYear', 'invoiceMonth', 'stakeHolderType'],
  data() {
    return {
      data: [],
      filterData: [],
      errors: '',
      loading: false,
      loadingSendEmail: false,
      dealerId: 0,
      isSendEmail: 'n'
    }
  },
  computed: {
    comGetRptData() {
      let arr = this.prosData
      let groupBy = (array, key) => {
        return array.reduce((result, obj) => {
          ;(result[obj[key]] = result[obj[key]] || []).push(obj)
          return result
        }, {})
      }

      let sortFilter = (a, b) => {
        return a.dealerId - b.dealerId
      }

      let a = groupBy(arr.sort(sortFilter), 'dealerId')
      let b = Object.values(a)

      this.filterData = arr
      return b
    },
    comGetTotal() {
      let arr = this.filterData
      let totalPrice = arr.reduce((accumulator, item) => {
        return accumulator + Number(item.client_lookup_values.dealerCommission)
      }, 0)
      return totalPrice
    }
  },
  methods: {
    // Get GST rate for each
    getGst(record) {
      return record.client_lookup_values.GST
    },

    //Dealer Commission
    getTotalValue(record) {
      let dealerCommission = 0

      if (record.client_lookup_values.dealerCommission) {
        dealerCommission = record.client_lookup_values.dealerCommission
      }

      return Number(dealerCommission).toFixed(2)
    },
    // Get commission exclude gst
    getIncomeWithOutGST(record) {
      return (
        Number(this.getTotalValue(record)) /
        (1 + Number(this.getGst(record)))
      ).toFixed(2)
    },
    /**
     * Get GST value for each
     * @param {*} record
     */
    getGSTValue(record) {
      return this.getTotalValue(record) - this.getIncomeWithOutGST(record)
    },

    // Get commission total
    getTotalIncome(item) {
      let sum = 0
      item.forEach((obj) => {
        sum += Number(this.getTotalValue(obj))
      })
      return sum.toFixed(2)
    },

    // Get commission total
    fnGetCommissionTotal(item) {
      let sum = 0
      item.forEach((obj) => {
        if (obj.client_lookup_values.dealerCommission) {
          sum += Number(obj.client_lookup_values.dealerCommission)
        }
      })
      return sum.toFixed(2)
    },
    // Get GST total value for each
    getTotalGSTValue(item) {
      let sum = 0
      item.forEach((record) => {
        sum += Number(this.getGSTValue(record))
      })
      return sum.toFixed(2)
    },

    // Get commission exclude gst total
    getTotalIncomeWithOutGST(item) {
      let sum = 0
      item.forEach((record) => {
        sum += Number(this.getIncomeWithOutGST(record))
      })
      return sum.toFixed(2)
    },

    /**
     * To Download Recipient Created Tax Invoice as a pdf document
     * @param {*} dealer
     */
    async fnDownloadInvoice(dealer) {
      this.loading = true

      this.dealerId = dealer[0].dealerId

      try {
        this.errors = {}

        const filePath = await invoiceService.download({
          invoiceYearView: this.invoiceYear,
          invoiceMonthView: this.invoiceMonth,
          stakeHolderTypeView: this.stakeHolderType,
          dealer: dealer
        })

        // Download from Export VSA RecipientCreatedTaxInvoice Report in temp folder
        window.open(`${store.state.serverPath}/` + filePath.data, '_blank')

        this.loading = false
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Data range',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Data range',
              'Something wrong'
            )
            break
        }
        console.log(error.response)
        this.loading = false
      }
    },

    /**
     * To send Recipient Created Tax Invoice via email with pdf attachment
     * @param {*} dealer
     */
    async fnSendInvoice(dealer) {
      this.loadingSendEmail = true

      this.dealerId = dealer[0].dealerId

      try {
        this.errors = {}

        const filePath = await invoiceService.sendInvoice({
          invoiceYearView: this.invoiceYear,
          invoiceMonthView: this.invoiceMonth,
          stakeHolderTypeView: this.stakeHolderType,
          dealer: dealer
        })

        // If the path exist that pdf document generate and send as a email
        if (filePath.data) {
          messageService.fnSweetAlertSuccessToast(
            'Recipient Created Tax Invoice',
            'Email send successfully'
          )
        }

        this.loadingSendEmail = false
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Data range',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Data range',
              'Something wrong'
            )
            break
        }
        console.log(error.response)
        this.loadingSendEmail = false
      }
    }
  }
}
</script>
<style>
@page {
  /* size: A4 portrait; */
  /* margin: 0cm 0cm; */
  width: 210mm;
  height: 290mm;
  margin: 0px 20px 0px 20px;
}
@media print {
  body * {
    visibility: hidden !important;
  }
  #reportConsoleLeftSide {
    display: none !important;
  }
  #reportConsoleRightSide.col-lg-8,
  #reportConsoleRightSide.col-md-8 {
    -ms-flex: 0 0 100%;
    -webkit-box-flex: 0;
    flex: 0 0 100%;
    max-width: 100%;
  }
  #report-4,
  #report-4 * {
    visibility: visible !important;
  }
  #report-4 {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    margin: 0;
    /* width: 210mm; */
    /* height: 297mm; */
  }
}
#report-4 .logo img {
  height: 125px !important;
  width: auto;
  border-radius: 0px;
}
#report-4 .img-fluid {
  max-width: 100% !important;
  height: auto !important;
}
#report-4 .tbl-header-blue {
  background-color: var(--iq-info);
  color: var(--iq-white);
}
#report-4 .tbl-header-gray {
  background-color: var(--iq-border-light);
  color: var(--iq-title-text);
}
#report-4 .tbl-header-blue th,
#report-4.tbl-header-gray td,
#report-4 td {
  font-size: 1.1rem;
}
#report-4 tr th,
#report-4 tr td {
  padding: 15px;
}
#report-4 tr.tbl-tr-no-data td {
  padding: 10px;
}
#report-4 tr.tbl-tr-no-data30-gray td {
  padding: 30px;
  background-color: var(--iq-border-light);
}
#report-4 .tbl-border-bottom {
  border-bottom: 1px solid var(--iq-border-light);
}
#report-4 .tbl-border-bottom3 {
  border-bottom: 3px solid var(--iq-border-light);
}
#report-4 .tbl-border-bottom4 {
  border-bottom: 3px solid var(--iq-info);
}
#report-4 .tbl-left {
  text-align: left;
}
#report-4 .tbl-right {
  text-align: right;
}
#report-4 .tbl-center {
  text-align: center;
}

#report-4 .footer {
  position: relative;
  bottom: 0;
}

#report-4 tr td p {
  font-size: 1.1rem;
}
.bg-info {
  background-color: var(--iq-info);
}
.text-info {
  color: #38afef;
}
.fw-600 {
  font-weight: 600;
}
.mb-0 {
  margin-bottom: 0;
}
</style>
